import algoliasearch from 'algoliasearch';
import getEnvValue from 'commons/getEnvValue';

// Lazy initialization - only create the client when actually needed
let algoliaClientInstance = null;

const getAlgoliaClient = () => {
  if (!algoliaClientInstance) {
    const appId =
      getEnvValue('NEXT_PUBLIC_ALGOLIA_APPID') ??
      getEnvValue('REACT_APP_ALGOLIA_APPID');
    const apiKey =
      getEnvValue('NEXT_PUBLIC_ALGOLIA_APIKEY') ??
      getEnvValue('REACT_APP_ALGOLIA_APIKEY');

    if (!appId || !apiKey) {
      // Environment variables not ready yet, client will be initialized when credentials are ready
      return null;
    }

    algoliaClientInstance = algoliasearch(appId, apiKey);
  }
  return algoliaClientInstance;
};

// Legacy export for backward compatibility (deprecated)
export const algoliaClient = {
  search: requests => {
    const client = getAlgoliaClient();
    if (!client) {
      // Algolia client not ready, returning empty results
      return Promise.resolve({
        results: requests.map(() => ({
          query: '',
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }
    return client.search(requests);
  },
  initIndex: indexName => {
    const client = getAlgoliaClient();
    if (!client) {
      // Algolia client not ready, cannot initialize index
      // Return a mock index object that won't break the component
      return {
        search: () => Promise.resolve({ hits: [], nbHits: 0 }),
        browseObjects: () => Promise.resolve({ hits: [], nbHits: 0 }),
      };
    }
    return client.initIndex(indexName);
  },
};

export const searchClient = {
  search(requests) {
    const client = getAlgoliaClient();
    if (!client) {
      // Algolia client not ready, returning empty results
      return Promise.resolve({
        results: requests.map(() => ({
          query: '',
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    // Inject clickAnalytics into all requests
    const updatedRequests = requests.map(request => ({
      ...request,
      params: {
        ...request.params,
        clickAnalytics: true,
      },
    }));

    return client.search(updatedRequests);
  },
};

export const noEmptySearchClient = {
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          query: '',
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    const client = getAlgoliaClient();
    if (!client) {
      // Algolia client not ready, returning empty results
      return Promise.resolve({
        results: requests.map(() => ({
          query: '',
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    // Inject clickAnalytics into all requests
    const updatedRequests = requests.map(request => ({
      ...request,
      params: {
        ...request.params,
        clickAnalytics: true,
      },
    }));

    return client.search(updatedRequests);
  },
};
